import React from 'react';

export default ({ color = '#FFFFFF', height, width, fill = 'none' }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M6.58586 8.00008L0.292969 1.70718L1.70718 0.292969L8.00008 6.58586L14.293 0.292969L15.7072 1.70718L9.41429 8.00008L15.7072 14.293L14.293 15.7072L8.00008 9.41429L1.70718 15.7072L0.292969 14.293L6.58586 8.00008Z" fill={color} />
  </svg>
)
